module.exports = __webpack_public_path__ + "18543fd58f9f52b51efc2b5838a5d843.jpg";